import { defineStore } from "pinia";
import { ElementSizeTracker } from "%/dynamic-component-editor/helpers/element-size-readout.mjs";

let tracker = null;

export const useSelectedElementSizeStore = defineStore("selected-element-size-store", {
  state: () => ({
    sizeById: {},
  }),
  actions: {
    observeNode(identifier, node) {
      this.tracker().observe(identifier, node);
    },
    detachNode(identifier) {
      this.tracker().forget(identifier);
    },
    tracker() {
      if (!tracker) {
        tracker = new ElementSizeTracker(window.ResizeObserver, {
          onMeasure: (identifier, size) => {
            const current = this.sizeById[identifier];
            if (current?.width === size.width && current?.height === size.height) {
              return;
            }
            this.sizeById[identifier] = size;
          },
          onForget: identifier => {
            delete this.sizeById[identifier];
          },
        });
      }
      return tracker;
    },
  },
});

export default useSelectedElementSizeStore;
